import { all, takeLatest } from 'redux-saga/effects';
import ApiNotifications from '~/sdk/notifications/email/ApiNotifications';
import clientConfig from '~/../parameters/client/config';
import disableNotificationsSagas from '../DisableNotifications/sagas';
import deleteSearchNotificationSagas from '../DeleteSearchNotification/sagas';
import resolvedParamsSagas from '../resolvedParams/sagas';
import searchNotificationsSagas from '../SearchNotifications/sagas';
import newsletterNotificationsSagas from '../NewsletterNotifications/sagas';
import fetchNotificationsSaga from './fetchNotifications';
import { FETCH_EMAIL_NOTIFICATIONS } from '../actionTypes';

const notificationsApi = new ApiNotifications(clientConfig.notificationApi);

export default function* notificationsManagerSagas() {
  yield all([
    takeLatest(FETCH_EMAIL_NOTIFICATIONS, fetchNotificationsSaga(notificationsApi)),
    resolvedParamsSagas(),
    disableNotificationsSagas(),
    searchNotificationsSagas(),
    newsletterNotificationsSagas(),
    deleteSearchNotificationSagas(),
  ]);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/sagas/index.js